<div class="register-container">
  <mat-card class="register-card">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>

    <mat-card-content>
      <h2 class="register-title">Create Account</h2>

      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <form [formGroup]="registerFormGroup" (ngSubmit)="register()" class="form-holder" *ngIf="!successMessage">
        <div class="name-row">
          <mat-form-field appearance="fill" class="half-width">
            <input
              matInput
              required
              formControlName="firstname"
              placeholder="First name"
              autocomplete="given-name" />
          </mat-form-field>

          <mat-form-field appearance="fill" class="half-width">
            <input
              matInput
              required
              formControlName="lastname"
              placeholder="Last name"
              autocomplete="family-name" />
          </mat-form-field>
        </div>
        <mat-error *ngIf="(registerFormGroup.get('firstname')?.invalid || registerFormGroup.get('lastname')?.invalid) && registerFormGroup.touched">
          First and last name are required
        </mat-error>

        <mat-form-field appearance="fill" class="width-full">
          <input
            matInput
            type="email"
            required
            formControlName="email"
            placeholder="Email"
            autocomplete="email" />
        </mat-form-field>
        <mat-error *ngIf="registerFormGroup.get('email')?.invalid && registerFormGroup.touched">
          Valid email is required
        </mat-error>

        <mat-form-field appearance="fill" class="width-full">
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            required
            formControlName="password"
            placeholder="Password"
            autocomplete="new-password" />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="registerFormGroup.get('password')?.invalid && registerFormGroup.touched">
          Password is required (min 8 characters)
        </mat-error>

        <mat-form-field appearance="fill" class="width-full">
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            required
            formControlName="confirmPassword"
            placeholder="Confirm Password"
            autocomplete="new-password" />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hideConfirmPassword = !hideConfirmPassword">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="registerFormGroup.get('confirmPassword')?.hasError('passwordMismatch')">
          Passwords do not match
        </mat-error>

        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="register-btn"
          [disabled]="registerFormGroup.invalid || isLoading">
          <span *ngIf="!isLoading">Create Account</span>
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
        </button>
      </form>

      <div class="divider" *ngIf="!successMessage">
        <span>or</span>
      </div>

      <div class="social-login" *ngIf="!successMessage">
        <asl-google-signin-button type="standard" size="large"></asl-google-signin-button>
      </div>
    </mat-card-content>

    <mat-card-footer class="register-footer">
      <span>Already have an account?</span>
      <a (click)="navigateToLogin()" class="login-link">Sign in</a>
    </mat-card-footer>
  </mat-card>
</div>
